// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"9937a755","125":"e7542f11","270":"72e59eb7","315":"ab438ac0","414":"4d376846","507":"b6342eeb","620":"276ba2d2","670":"00e6eafc","671":"200e95b4","888":"5e9e56de","934":"2f826b63"}[chunkId] + ".chunk.css";
};